/**
 * Copyright (c) 2023, WSO2 LLC. (https://www.wso2.com). All Rights Reserved.
 *
 * WSO2 LLC. licenses this file to you under the Apache License,
 * Version 2.0 (the "License"); you may not use this file except
 * in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied. See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */

import { Box, Grid, Typography } from "@mui/material";
import "./Uptime.css";
import PropTypes from "prop-types";
import React from "react";

/**
 * Uptime component
 * Description: This component is used to display the uptime of a service.
 */
function Uptime({ availability, duration }) {
  return (
    <Grid className="uptime" item rowSpacing={ 2 } xs={ 12 } md sm lg sx={ { mb: 0.5, px: 2,  py: 1  } }>
      <Typography component="div">
        <Box>
          { /* Render the availability percentage */ }
          <Typography variant="body1" sx={ { fontWeight: "bold" } }>
            { parseFloat(
              Math.floor(availability * 10 ** window.ENV.uptimePrecision) / 10 ** window.ENV.uptimePrecision
            ).toFixed(window.ENV.uptimePrecision) }
            %
          </Typography>
        </Box>
        <Box>
          { /* Render the availability duration */ }
          <Typography variant="body2" color="text.secondary">
            { duration }
          </Typography>
        </Box>
      </Typography>
    </Grid>
  );
}

Uptime.propTypes = {
  availability: PropTypes.number,
  duration: PropTypes.string
};

export default Uptime;
